import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { PurchaseServiceService } from 'src/app/vendor-panel/purchase-order/purchase-service.service';
import { PurchaseOrderService } from '../../purchase-order.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-po-remark',
  templateUrl: './po-remark.component.html',
  styleUrls: ['./po-remark.component.scss']
})
export class PoRemarkComponent {

  remark: any;
  companyId: any;
  emp_id: any;

  constructor(
    public dialogRef: MatDialogRef<PoRemarkComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private purchaseService: PurchaseOrderService,
    private toastr: ToastrService,
    private router: Router
  ) {
    // Log what we received
    console.log('📋 PoRemarkComponent received dialogData:', this.dialogData);
  }

  ngOnInit(): void {
    // ✅ FIX: Pehle dialogData se emp_id lo (jo parent se aaya hai)
    if (this.dialogData && this.dialogData.emp_id) {
      this.emp_id = this.dialogData.emp_id;
      console.log('✅ Using emp_id from dialogData:', this.emp_id);
    } else {
      // Fallback: Agar dialogData mein nahi hai toh localStorage se lo
      const storedData = localStorage.getItem('user_details') ?? "{}";
      const userDetails = JSON.parse(storedData);
      if (userDetails && userDetails.companyId) {
        this.companyId = userDetails.companyId;
        this.emp_id = userDetails.employeeId;
        console.log('⚠️ Using emp_id from localStorage:', this.emp_id);
      }
    }

    console.log('📤 Final emp_id to be sent:', this.emp_id);
    console.log('📤 PO ID:', this.dialogData?.po_id);
    console.log('📤 Status:', this.dialogData?.status);
  }

  closeDialog() {
    this.dialogRef.close({ event: 'Cancel' });
  }

  submit() {
  
    const data = {
      emp_id: this.emp_id,  
      po_id: this.dialogData?.po_id,
      approvalStatus: this.dialogData?.status,
      remark: this.remark
      
    };

    console.log('📤 Sending API Payload:', data);

    if (data.emp_id && data.po_id) {
      this.purchaseService.approvePoData(data).subscribe(
        (res: any) => {
          console.log('✅ API Response:', res);
          if (this.dialogData.status == 'Approved') {
            this.toastr.success('Purchase Order Approved Successfully!', '', { timeOut: 2000 });
          } else {
            this.toastr.success('Purchase Order Rejected Successfully!', '', { timeOut: 2000 });
          }
          this.closeDialog();
          this.router.navigate(['/admin/purchase-order/pending-purchase-order']);
        },
        (err: any) => {
          console.error('❌ API Error:', err);
          this.toastr.error(err?.error?.message || 'Failed to Approve Purchase Order', '', { timeOut: 2000 });
        }
      );
    } else {
      this.toastr.warning('Missing required data to approve the purchase order.');
    }
  }
}
